<icon [record]="record"
      hasBorder
      [type]="selectedType"
      [attr.medium]="mediumIcon"
      [type]="record.coverageType"
      [attr.disabled]="isDisabled"
      [matMenuTriggerFor]="disabled ? null : assignmentsMenu"></icon>
<span *ngIf="showLabel"
      class="assignment-type__title">{{selectedTypeLabel}}</span>
<mat-menu #assignmentsMenu="matMenu">
    <mat-selection-list hideSingleSelectionIndicator
                        *ngIf="!disabled"
                        [multiple]="false">
        <mat-list-option *ngFor="let item of assignmentTypes"
                         (click)="select(item.id)"
                         [value]="item?.id">
            <icon matListItemIcon
                  [type]="item.id"></icon>
            <div matListItemTitle>{{item.title}}</div>
        </mat-list-option>
    </mat-selection-list>
</mat-menu>